import React, { Component } from "react";
import MainPicture from "../Section/MainPicture";
import image from './img/internet-of-things.png';
import LeftPictureBackground from "../Section/LeftPictureBackground";
import CheckModule from "../Section/CheckModule";

import picturemethodo from "./img/box.png";
import picturequality from "./img/iot-cloud.jpg";
import RightPicture from "../Section/RightPicture";
import pictureevol from "./img/objets-connectes.jpg";
import technologies from "../../../static/images/technologies.png";
import symfony from "../../pages/img/symfony.png";
import nodejs from "./img/nodejs.png";
import angular from "./img/angular-react.png";
import database from "./img/base-de-donnee.png";
import elasticsearch from "./img/elasticsearch.png";
import html from "./img/html-css-js.png";
import styles from "./ApplicationIot.module.scss";

class ApplicationIot extends Component {
  render() {
    let title = "Application Web";
    let goto = "En découvrir plus";
    let alt = "test";
    let description = ["Fort de notre expérience dans le ", <strong>domaine de l'embarqué</strong>, " et dans le milieu de l'industrie",
    " nous réalisons des ", <strong>applications web, mobile ou embarquée</strong>, " dédiées au monde l'Internet des objets.", 
    ];


    let smalltitle = "Le meilleur du matériel et du logiciel";
    let titlemethodo = "une solution matérielle et logicielle sur-mesure pour vos objets connectés";
    let descriptionmethodo = [
        "Notre expertise applicative couplée à notre savoir-faire dans l'informatique industrielle vous apporte une solution globale et cohérente pour la mise en place d'une solution sécurisée et fiable.", 
        <br />, <br />, "Nos réalisations sont sur-mesure et adaptées à vos besoins, afin que l'ensemble de la solution corresponde à 100% à vos attentes sans superflu."
        ];
    let pictureMethodo = picturemethodo;
    let altmethodo = "Méthodologie agile Scrum en image";



    let smalltitleevol = "Les objets connectés au coeur de votre infrastructure";
    let titleevol = "Des applications Web robustes pour vos infrastructures IoT";
    let descriptionevol = ["Nous réalisons des applications dédiées au monde des objets connectés qui répondent à vos contraintes (Volumétrie, faible latence, faible débit, ...).",
<br />,<br />, "Grâce à nos méthodologies de développement éprouvées, nous concevons des applications sécurisées et robustes."];

    let altevol = "Intégration du portail dans votre système d'information";

    let smalltitleCheck = "Le cloud s'invite dans votre industrie" ;
    let titleCheck = "L'expertise industrielle au travers d'application IoT orienté Cloud";
    let subtitle1Check = "Collecter";
    let text1Check = ["Nos applications peuvent récolter de grands volumes de données à partir de vos objets connectés. Nous utilisons les services Cloud (AWS Amazon ou Microsoft Azure) ou des infrastructures spécifiques."];
    let subtitle2Check = "Analyser";
    let text2Check = ["Analyser et visualiser de grands volumes de données qui suivent l'évolution de vos objets. Nous réalisons des ",<a href="/portail-web-collaboratif" title="Les portails Web">portails</a>," et des ",<a href="/application-mobile" title="Applications mobiles">applications mobiles</a>," spécifiques de suivi pour vous, vos clients et/ou vos partenaires!"];
    let subtitle3Check = "Agir";
    let text3Check = ["Facilitez ou automatisez la prise de décision et l'action envers votre infrastructure IoT."];
    let pictureCheck = picturequality;
    let altCheck = "L'IoT facile";


    return (
      <div className="generic-services">
        <MainPicture title="L'innovation au coeur de l'IoT" description={description} picture={image} alt={alt} />
        <RightPicture smalltitle={smalltitleevol} title={titleevol} description={descriptionevol} picture={pictureevol} alt={altevol} />
        <LeftPictureBackground smalltitle={smalltitle} title={titlemethodo} description={descriptionmethodo} picture={pictureMethodo} alt={altmethodo} />
        <CheckModule 
                smalltitle={smalltitleCheck} 
                title={titleCheck}
                subtitle1={subtitle1Check}
                text1={text1Check}
                subtitle2={subtitle2Check}
                text2={text2Check}
                subtitle3={subtitle3Check}
                text3={text3Check}
                picture={pictureCheck}
                alt={altCheck}
        />

        <section className={`${styles.iot} row-bottom-padded-lg row-top-padded-lg`}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col text-center">
                        <h2>Votre écosystème IoT propulsé par nos solutions</h2>
                        <p>Nous avons créé des outils de configuration, pilotage et d'analyse d'infrastructure IoT à l'aide des <a href="https://www.integral-system.fr/fr_FR/taxons/iot-sans-fil-adm2" title="Modules d'acquisition de données industriels" target="_blank">modules d'acquisitions de données WISE 4000</a>. Sous forme de modules Web (Passerelle IoT), retrouvez et analysez vos données directement dans notre portail Web métier !</p>
                        <a href="/contact" title="Contacter Integral Service" className={`btn btn-primary ${styles.btnwrappre}`}>N'hésitez pas à nous contacter pour en savoir plus !</a>
                    </div>
                </div>
            </div>
        </section>
      </div>
    );
  }
}

export default ApplicationIot;



// WEBPACK FOOTER //
// ./src/components/Page/ApplicationIot.jsx